<div class="container perceptron-container pt-3">
    <!-- <button class="btn btn-primary" (click)="height = height +10">inc</button>
    <button class="btn btn-secondary" (click)="height = height -10">dec</button> -->
    <iframe width="100%" [height]="height" [src]="urlSafe"></iframe>
    <!-- <iframe width="100%" height="100%" [src]="urlSafe"></iframe> -->
</div>
